import { useMutation } from '@tanstack/react-query';
import { TenantsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useTenantsControllerRestoreTenantMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['tenantsControllerRestoreTenant', accessControlScope],
        mutationFn: async (args) => {
            const api = new TenantsApi(accessControlConfig);
            return api.tenantsControllerRestoreTenant(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useTenantsControllerRestoreTenantMutation.js.map